import { render, staticRenderFns } from "./CreateWinesModal.vue?vue&type=template&id=3154d2c7"
import script from "./CreateWinesModal.vue?vue&type=script&lang=js"
export * from "./CreateWinesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports